import { useState, useEffect, useRef } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import { useNavigate, useParams } from 'react-router-dom';

export function TrabalhadorEditar() {
    const { idTrabalhador } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [nome, setNome] = useState("");
    const [cpf, setCpf] = useState("");
    const [celular, setCelular] = useState("");
    const [rg, setRg] = useState("");
    const [sexo, setSexo] = useState("");
    const [data_nascimento, setDataNascimento] = useState("");
    const [senha, setSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate()


    const [error, setError] = useState("");

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const inputRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    useEffect(() => {
        const buscarDadosResponsavel = async () => {
            if (idTrabalhador) {
                try {
                    const response = await api.get(`/trabalhadores/listar/${idTrabalhador}`);
                    const trabalhador = response.data.data;

                    setNome(trabalhador.trabalhador.nome);
                    setCpf(trabalhador.trabalhador.cpf);
                    setCelular(trabalhador.trabalhador.celular);
                    setRg(trabalhador.trabalhador.rg);

                    const formattedDate = trabalhador.trabalhador.data_nascimento.split('T')[0];
                    setDataNascimento(formattedDate);

                    setEmail(trabalhador.usuario.email);

                } catch (error) {
                    console.error('Erro ao buscar dados da empresa', error);
                }
            }
        };

        buscarDadosResponsavel();
    }, [idTrabalhador]);

    const validateForm = () => {
        if (!email.includes('@')) {
            setError("Por favor, insira um e-mail válido.");
            return false;
        }
        if (!nome) {
            setError("Por favor, insira um nome.")
            return false;
        }
        if (!cpf) {
            setError("Por favor, insira um cpf.");
            return false;
        }
        if (!rg) {
            setError("Por favor, insira um rg.")
            return false;
        }
        if (!celular) {
            setError("Por favor, insira um celular.")
            return false
        }
        if (!data_nascimento) {
            setError("Por favor, insira a data de nascimento.")
            return false
        }
        if (!senha) {
            setError("Por favor, insira uma senha.")
            return false
        }

        if (!confirmarSenha) {
            setError("Por favor, insira confirme sua senha.")
            return false
        }

        if (senha && confirmarSenha && senha !== confirmarSenha) {
            setError("As senhas informadas não coincidem.")
            return false
        }
        setError("");
        return true;
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        const payload = {
            nome,
            cpf,
            rg,
            celular,
            data_nascimento,
            email,
            senha
        }

        try {
            const response = await api.post(`/trabalhadores/editar/${idTrabalhador}`, payload);
            if (response.data.message) {
                setAlert({ message: response.data.message, variant: 'danger', show: true });
            } else {
                setAlert({ message: 'Trabalhador atualizado com sucesso!', variant: 'success', show: true });
                setTimeout(() => {
                    return navigate('/trabalhadores');
                }, 1000);
            }
        } catch (error) {
            console.error('Erro ao atualizar dados do trabalhador:', error);
        }
    };

    const handleSelectSexo = (value: any) => {
        setSexo(value);
    };



    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Informações Pessoais</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Nome *' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='CPF *' htmlFor="cpf" />
                                <InputMask
                                    mask="999.999.999-99"
                                    id='cpf'
                                    value={cpf}
                                    onChange={(e: any) => setCpf(e.target.value)}
                                    placeholder="Digite o CPF"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row className='my-4'>
                        {/* Data de Nascimento */}
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Data de Nascimento' htmlFor="dataNascimento" />
                                <input
                                    type="date"
                                    id="dataNascimento"
                                    value={data_nascimento}
                                    onChange={(e) => setDataNascimento(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='RG' htmlFor="rg" />
                                <InputMask
                                    mask="99.999.999-9"
                                    value={rg}
                                    onChange={(e: any) => setRg(e.target.value)}
                                    placeholder="Digite o RG"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {/* Email */}
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Email' htmlFor="email" />
                                <input
                                    type="text"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                    placeholder='example@example.com'
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Button className="btn-main mt-4" type="submit" onClick={handleSubmit}>Salvar Alterações</Button>
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
